<template>
    <div class="text-lg text-gray-700 font-semibold">
        <slot />
    </div>
</template>
